import React from 'react';
import ActivityRow from './activity_row';

export default ({ items }) => <div>{items.map((item)=> <ActivityRow key={item.id} {...item}/>)}</div>
